export let BiCycle = /*#__PURE__*/function (BiCycle) {
  BiCycle[BiCycle["ONE_YEAR"] = 6] = "ONE_YEAR";
  BiCycle[BiCycle["TWO_YEAR"] = 7] = "TWO_YEAR";
  BiCycle[BiCycle["THREE_YEAR"] = 8] = "THREE_YEAR";
  BiCycle[BiCycle["ONE_MONTH"] = 3] = "ONE_MONTH";
  BiCycle[BiCycle["THREE_MONTH"] = 4] = "THREE_MONTH";
  return BiCycle;
}({});
export const BI_CYCLE_MAP = {
  '1-YEAR': BiCycle.ONE_YEAR,
  '2-YEAR': BiCycle.TWO_YEAR,
  '3-YEAR': BiCycle.THREE_YEAR,
  '1-MONTH': BiCycle.ONE_MONTH,
  '3-MONTH': BiCycle.THREE_MONTH
};
//# sourceMappingURL=bi-consts.js.map